<template>
  <div>
    <audio id="audioContainer">
      <source src="/static/assets/sound/scratch.mp3"></source>
    </audio>
  </div>
</template>

<script>
    import tr from '@/mixins/transactions'
    export default {
        name: 'orderAlert',
        mixins: [tr],
        data () {
            return {
                msg: '',
                IntV: null,
                t: this.$root.t
            }
        },
        destroyed () {
            clearInterval(this.IntV);
        },
        mounted() {
              this.check
              this.IntV = setInterval(this.check, 15000);
        },
        methods: {
            check () {

                this.fetchPendingOrders().then(response => {
                    // get body data
                    window.pendingTransactions = response.body.all;
                    var s = response.body.in_minutes;

                    var paymentCount = (response.body.all.payment.total > 99) ? '99+' : response.body.all.payment.total;
                    var withdrawCount = (response.body.all.withdrawal.total > 99) ? '99+' : response.body.all.withdrawal.total;

                    window.document.getElementById("paymentCount").innerHTML = paymentCount;
                    window.document.getElementById("withdrawCount").innerHTML = withdrawCount;

                    if(s.payment.total > 0 || s.withdrawal.total)
                    {
                        if(!document.hasFocus()){
                            this.notifyMe(this.t.pending_incomes+': '+s.payment.total +' - '+ this.t.pending_outcomes+': '+s.withdrawal.total);
                            this.playSound();
                        }
                    }

                }, response => {

                })
            },
            playSound () {
                const audioContainer = document.getElementById("audioContainer");
                audioContainer.play();
            },
            notifyMe(msg) {
                // Let's check if the browser supports notifications
                if (!("Notification" in window)) {
                    alert("This browser does not support desktop notification");
                }

                // Let's check whether notification permissions have already been granted
                else if (Notification.permission === "granted") {
                    // If it's okay let's create a notification
                    var notification = new Notification(msg);
                }

                // Otherwise, we need to ask the user for permission
                else if (Notification.permission !== "denied") {
                    Notification.requestPermission().then(function (permission) {
                        // If the user accepts, let's create a notification
                        if (permission === "granted") {
                            var notification = new Notification("Thanks for opened notifications!");
                        }
                    });
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/orderAlert.vue